import { useState, useCallback, useEffect } from "react";
import { useUpdatePermission, useGetPermissions, useTotalStaff } from "../Use-auth";
import Button from "./Button";

export default function AddProject({ canViewManagerNewProject, setShowAddProjectInput, currentUser,
    projectName, createProject, setProjectName, addStatusMutation, showAddProjectInput,
    Input, TaskEmployees, employees, X, ProjectList, projects, activeProjectId, setActiveProjectId,
    SucessToast, activeSubProjectId, setActiveSubProjectId, setActive, statuses
}) {

    const { data: totalStaff = [] } = useTotalStaff();
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("success");
    const [isMultiProject, setIsMultiProject] = useState(false);
    const [sharedWith, setSharedWith] = useState([]);
    const [status, setStatus] = useState("Not started");
    const updatePermission = useUpdatePermission();
    const [loading, setLoading] = useState(false);
    const [isPinned, setIsPinned] = useState(false);
    const [orderedProjects, setOrderedProjects] = useState(projects || []);
    const [selectProjectFilter, setSelectProjectFilter] = useState(() => {
        const filter = new URLSearchParams(window.location.search).get("filter") || "";
        return filter === "all" ? "" : filter;
    });
    const [searchTerm, setSearchTerm] = useState("");

    const { data: permissionsApi = [], } = useGetPermissions();

    const DEFAULT_STATUSES = ["Pending", "Progress", "Testing", "Complete",];

    const matchedStaff = totalStaff.find(
        emp => emp.employeeId === currentUser?.userId
    );
    const permissionByUserId = {};

    permissionsApi.forEach(p => {
        const uid = p.user_id || p.userId;
        permissionByUserId[uid] = p;
    });

    const handleTaskAdd = useCallback(() => {
        if (!projectName.trim()) {
            setToastMessage("Please enter Project Name first");
            setToastType("error");
            return;
        }

        setLoading(true);

        let finalSharedWith = [...sharedWith];

        if (
            matchedStaff?.employeeId &&
            !finalSharedWith.includes(matchedStaff.employeeId)
        ) {
            finalSharedWith.push(matchedStaff.employeeId);
        }

        const payload = {
            projectName,
            createdBy: {
                userId: matchedStaff?.employeeId,
                fullName: currentUser?.fullName || "Unknown",
                email: matchedStaff?.officeEmail,
            },
            sharedWith: finalSharedWith,
            status,
            isMultiProject,
            isPinned,
            order: 0,
            subProjectsData: isMultiProject ? [] : [],
        };

        createProject.mutate(payload, {
            onSuccess: async (res) => {

                const projectId = res?.data?.id?.toString();
                const newProject = res?.data;
                 console.log("Payload:", payload);
                setOrderedProjects(prev => [newProject, ...prev]);

                setShowAddProjectInput(false);
                setProjectName("");
                setStatus("Not started");
                setSharedWith([]);
                setIsPinned(false);
                setIsMultiProject(false);

                setToastMessage("Project created successfully");
                setToastType("success");

                finalSharedWith.forEach(employeeId => {

                    const employee = employees.find(e => e.employeeId === employeeId);
                    if (!employee) return;

                    const permission = permissionsApi.find(
                        p => p.user_id === employee.employeeId || p.userId === employee.employeeId
                    );
                    if (!permission) return;

                    const rawProjectIds = permission.employees?.project_id;

                    const existingProjects = Array.isArray(rawProjectIds)
                        ? rawProjectIds.map(id => id.toString())
                        : [];

                    if (existingProjects.includes(projectId)) return;

                    updatePermission.mutate(
                        {
                            id: permission.id || permission.permission_id || permission._id,
                            employees: {
                                ...permission.employees,
                                project_show: true,
                                project_id: [...existingProjects, projectId],
                            },
                            management: permission.management || {},
                        },
                        {
                            onSuccess: (res) =>
                                console.log("Permission updated:", res),

                            onError: (err) =>
                                console.error("Permission update failed:", err),
                        }
                    );

                });

                if (!isMultiProject) {
                    try {
                        for (const status of DEFAULT_STATUSES) {
                            await addStatusMutation.mutateAsync({
                                projectId,
                                status,
                                createdBy: currentUser?.username || "Unknown",
                            });
                        }
                    } catch (err) {
                        console.error("Background status add failed", err);
                    }
                }

                setLoading(false);
            },

            onError: (err) => {
                console.error("Error creating project:", err);

                setToastMessage("Error creating project: " + err.message);
                setToastType("error");

                setLoading(false);
            },
        });

    }, [
        projectName,
        currentUser,
        createProject,
        addStatusMutation,
        sharedWith,
        isMultiProject,
        status,
        isPinned
    ]);

    return (
        <div className="space-y-2 mb-5 p-2 sm:p-6 mt-10">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-0">
                {canViewManagerNewProject &&
                    (!activeProjectId ||
                        projects.find(p => p._id === activeProjectId)?.isMultiProject === false
                    ) && (
                        <div className="inline-block mb-5 sm:mb-10">
                            <Button
                                onClick={() => setShowAddProjectInput(true)}
                            >
                                + New Project
                            </Button>
                        </div>
                    )}

                {!activeProjectId && !activeSubProjectId && (
                    <div className="mb-5 sm:mb-10 flex gap-2 flex-row sm:items-center sm:justify-end sm:max-w-md sm:ml-auto">
                        <select
                            name="projectFilter"
                            id="projectFilter"
                            className="input text-sm max-[540px]:text-xs flex-1 min-w-[150px] sm:min-w-[150px] sm:max-w-[200px] px-3 py-2 max-[540px]:px-2 max-[540px]:py-2"
                            value={selectProjectFilter}
                            onChange={(e) => setSelectProjectFilter(e.target.value)}
                        >
                            <option value="">All Projects</option>
                            <option value="Not started">Not started</option>
                            <option value="In Progress">Active projects</option>
                            <option value="Over Due">Over Due Projects</option>
                            <option value="On Hold">On Hold projects</option>
                            <option value="Lost">Lost Projects</option>
                            <option value="Completed">Completed Projects</option>
                        </select>

                        <Input
                            type="search"
                            placeholder="Search project..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full sm:w-52"
                        />

                    </div>)}
            </div>

            {showAddProjectInput && (
                <div
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-[99999] p-2 max-[540px]:p-1"
                    onClick={() => setShowAddProjectInput(false)}
                >
                    <div
                        className="
        bg-white rounded-xl shadow-2xl
        w-full max-w-2xl
        max-[540px]:max-w-[95%]
        max-h-[90vh]
        p-6 max-[540px]:p-3
        relative animate-scaleIn
        "
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <div
                            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 cursor-pointer"
                            onClick={() => setShowAddProjectInput(false)}
                        >
                            <X size={20} />
                        </div>

                        <h3 className="text-xl max-[540px]:text-base font-semibold mb-5 max-[540px]:mb-3 text-center">
                            Add New Project</h3>

                        <div className="mb-4">
                            <Input
                                value={projectName}
                                onChange={(e) => setProjectName(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        handleTaskAdd({ projectName, isMultiProject, sharedWith });
                                        setShowAddProjectInput(false);
                                    }
                                }}
                                placeholder="Enter Project Name"
                                className="w-full border border-gray-300 px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                        </div>

                        <div className="grid grid-cols-2 gap-3 mb-4 max-[540px]:mb-3">
                            <Button
                                active={!isMultiProject}
                                onClick={() => setIsMultiProject(false)}
                            >
                                Single Project
                            </Button>

                            <Button
                                active={isMultiProject}
                                onClick={() => setIsMultiProject(true)}
                            >
                                Multi Project
                            </Button>
                        </div>
                        <div className="mb-4 flex items-center justify-between">
                            <label className="text-sm font-medium text-gray-700">
                                Pin Project
                            </label>

                            <input
                                type="checkbox"
                                checked={isPinned}
                                onChange={(e) => setIsPinned(e.target.checked)}
                                className="w-4 h-4 cursor-pointer"
                            />
                        </div>

                        <div className="mb-4 max-[540px]:mb-3">
                            <label className="block mb-1 text-sm max-[540px]:text-xs font-medium text-gray-700">
                                Status
                            </label>

                            <select
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                                className="
          w-full border border-gray-300 rounded-lg
          px-3 py-2 
          text-sm max-[540px]:text-xs
          focus:outline-none focus:ring-2 focus:ring-blue-400
        "
                            >
                                <option value="">Select Status</option>
                                <option value="Not started">Not started</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Over Due">Over Due</option>
                                <option value="On Hold">On Hold</option>
                                <option value="Lost">Lost</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </div>
                        <div className="mb-4 flex justify-between items-center">
                            <label className="block mb-1 text-sm max-[540px]:text-xs font-medium text-gray-700">
                                Share With
                            </label>
                            <TaskEmployees
                                selected={sharedWith}
                                onChange={setSharedWith}
                                employees={employees}
                                className="custom-dropdown"
                                placement="top"
                                align="right"
                            />
                        </div>

                        <div className="flex justify-end">
                            <Button
                                onClick={handleTaskAdd}
                                variant="success"
                                disabled={loading}
                                className="flex items-center justify-center gap-2 min-w-[120px]"
                            >
                                {loading ? (
                                    <>
                                        Processing...
                                        <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                    </>
                                ) : (
                                    "Continue"
                                )}
                            </Button>
                        </div>
                    </div>
                </div>
            )}

            <ProjectList
                projects={projects}
                orderedProjects={orderedProjects}
                setOrderedProjects={setOrderedProjects}
                activeProjectId={activeProjectId}
                setActiveProjectId={setActiveProjectId}
                currentUser={currentUser}
                TaskEmployees={TaskEmployees}
                employees={employees}
                activeSubProjectId={activeSubProjectId}
                setActiveSubProjectId={setActiveSubProjectId}
                totalStaff={totalStaff}
                setActive={setActive}
                selectProjectFilter={selectProjectFilter}
                setSelectProjectFilter={setSelectProjectFilter}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                statuses={statuses}
            />
            {toastMessage && (
                <SucessToast type={toastType} message={toastMessage} />
            )}
        </div>
    )
}
